import React from "react";
import { Modal } from "react-bootstrap";
import { SocialIcon } from "../../../../util/Icons";
import SocialUserDetails from "../../components/SocialUsersDetails";

const ViewSocialUserModal = ({ showViewSocialUserModal, details, onHide }) => {
  return (
    <Modal
      show={showViewSocialUserModal}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
            <SocialIcon />
          </span>
          {details?.username}
        </Modal.Title>
        <button type="button" className="close" onClick={onHide}>
          <span aria-hidden="true" className="d-block">
            ×
          </span>
          <span className="sr-only">Close</span>
        </button>
      </Modal.Header>
      <Modal.Body className="p-0 pb-8" style={{height: "calc(100vh - 220px)"}}>
        <SocialUserDetails details={details} />
      </Modal.Body>
    </Modal>
  );
};

export default ViewSocialUserModal;
